function staticSlider(element, interval) {
  const warpper = element;
  const slideElements = Array.from(element.children);
  let firstClone = slideElements[0].cloneNode(true);
  warpper.appendChild(firstClone);
  function slide() {
    for (let i = 1; i <= slideElements.length + 1; i++) {
      setTimeout(() => {
        i == slideElements.length + 1
          ? (element.style.transition = "none")
          : (element.style.transition = "transform 0.3s ease-in-out");
        element.style.transform =
          i == slideElements.length + 1
            ? `translateX(0%)`
            : `translateX(-${i * 100}%)`;
        i == slideElements.length + 1 ? slide() : "";
      }, i * interval);
    }
  }
  slide();
}
const staticSliderEvent = new Event("static-slider");
window.dispatchEvent(staticSliderEvent);
